import clsx from 'clsx';
import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import { T, TPlainTextKey } from '../../../../../Translations';

interface Props {
  text: TPlainTextKey;
  children: ReactNode;
}

function BigNumber({ text, children }: Props) {
  return (
    <div
      className={clsx(
        'flex flex-col gap-3 items-center rounded-md bg-white px-8 py-10 drop-shadow-md flex-grow',
      )}
    >
      <div className="text-2xl font-medium">{children}</div>
      <T kind={text} />
    </div>
  );
}

export default observer(BigNumber);
